import configSelector from "../external/configSelector";
import checkLightOrDark from "../external/helpers/checkLightOrDark";
import colorConstants from "../constants/colors.json";

export function getHeaderColors() {
  const headerConfig = configSelector.getGlobalComponent({ name: `header` });
  const headerBackgroundColor =
    headerConfig?.customizations?.backgroundColor || "#f1f1f1";
  const lightOrDark = checkLightOrDark(headerBackgroundColor);
  const headerColors =
    lightOrDark === "light"
      ? colorConstants?.colors?.header?.light
      : colorConstants?.colors?.header?.dark;

  const badgeBackgroundColor =
    headerConfig?.customizations?.badgeBackgroundColor || "#000000";
  const badgeLightOrDark = checkLightOrDark(badgeBackgroundColor);
  const badgeColors =
    badgeLightOrDark === "light"
      ? colorConstants?.colors?.header?.light
      : colorConstants?.colors?.header?.dark;

  return {
    backgroundColor: headerBackgroundColor,
    textColor: headerColors.textColor,
    iconColor: headerColors.iconColor,
    badgeBackgroundColor,
    badgeTextColor: badgeColors.textColor,
  };
}
